import { TextProps } from "../../types/textTypes";
import "./h1.scss";

const H1: React.FC<TextProps> = ({ children, className }) => {
  return <h1 className={`h1 ${className ? className : ""}`}>{children}</h1>;
};

export default H1;
